import {WixSdk} from '@wix/js-sdk-wrapper';
import {BI_ERRORS} from '../../biErrorLogger/biErrors';
import {errorLogger} from '../../errorLogger/errorLogger';
import {extractFont, presetGetter} from './fonts/fonts';

export const siteSettingsApi = {
  obtain() {
    const siteSettingsPromise = Promise.all([
      WixSdk.Styles.getStyleParams(),
      WixSdk.Styles.getSiteColors(),
      WixSdk.Styles.getSiteTextPresets(),
      WixSdk.Activities.getUserSessionToken(),
    ]);
    return siteSettingsPromise
      .then(([styleParams, siteColors, siteTextPresets, sToken]) => {
        const getPreset = presetGetter(siteTextPresets);
        return {
          styleParams,
          siteColors,
          siteTextPresets,
          sToken,
          fonts: {
            title: extractFont(styleParams.fonts.trackTitleFont || styleParams.fonts.titleFont) || getPreset('Body-M'),
            trackTitle: extractFont(styleParams.fonts.trackFont) || getPreset('Body-M'),
          },
        };
      })
      .catch((reason) => {
        errorLogger.logError(
          {
            bi: BI_ERRORS.getWindow.siteSettings.obtain,
          },
          {reason},
        );
        return Promise.reject(reason);
      });
  },
};
